module.exports = "/_next/static/images/ca8b510e1b19d70c702043418c0c99af-two-people-looking-xs@3x.jpg";